var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWiimg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5321 18.6582C18.6272 18.6594 18.7208 18.6425 18.8077 18.6083C18.9812 18.5378 19.1165 18.4006 19.1846 18.2262C19.2175 18.1388 19.2332 18.0451 19.2306 17.95L18.6986 1.63906C18.6923 1.44764 18.6103 1.26263 18.4704 1.12473C18.3306 0.986831 18.1445 0.907343 17.953 0.90375C17.7615 0.900156 17.5803 0.97275 17.4493 1.10556C17.3184 1.23838 17.2483 1.42053 17.2545 1.61196L17.7319 16.1838L2.15414 0.820158C2.0145 0.682436 1.82861 0.603046 1.63736 0.599457C1.44611 0.595867 1.26517 0.668371 1.13435 0.801018C1.00352 0.933665 0.933532 1.11559 0.939768 1.30677C0.946004 1.49795 1.02796 1.68273 1.1676 1.82045L16.7453 17.1841L2.16937 16.9095C1.97788 16.9059 1.79672 16.9785 1.66573 17.1113C1.53474 17.2441 1.46466 17.4262 1.4709 17.6177C1.47715 17.8091 1.5592 17.9941 1.69902 18.132C1.83884 18.2699 2.02497 18.3494 2.21646 18.353L18.5321 18.6582Z",
    fill: "#017FDA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiimg);
export default __webpack_public_path__ + "static/media/wiimg.21c8169d.svg";
export { ForwardRef as ReactComponent };